module.exports = __webpack_public_path__ + "static/media/cellfinate_imagen_ambos.b71c68c4.jpg";